import { faTimes, faBars, faChevronDown, faChevronUp } from '@fortawesome/pro-light-svg-icons'
import { Dispatch, SetStateAction, useState } from 'react'
import { WhiteBox } from '../../../../../baseComponents/AppLayout/WhiteBox'
import { UserPermissions } from '../../../../../baseComponents/CreateRoutering/types'
import { BigTitleAndRightLayout } from '../../../../../baseComponents/Layout/TitleAndRightLayout'
import LoaderDecider from '../../../../../baseComponents/LoaderDecider'
import TwinIcon from '../../../../../baseComponents/TwinIcon'
import InputTable, { InputTableNew } from '../../../../../baseComponents/TwinTable/InputTableLayout/InputTable'
import { ColumnITLayoutTableConfiguration, ITHookFunctionTy, InputTableFooterFullProps } from '../../../../../baseComponents/TwinTable/InputTableLayout/InputTable/types'
import { InputTableURLsTable, OrderHeaderURLs, InputTableLayoutData } from '../../../../../baseComponents/TwinTable/InputTableLayout/types'
import { TableWithoutVirtualListingRowRenderer } from '../../../../../baseComponents/TwinTable/TableWithoutVirtualListing/types'
import { TableData, TableConfiguration, HeaderChangesTy } from '../../../../../baseComponents/TwinTable/types'
import { TwinDictionary } from '../../../../../utils/globals/dictionary'
import { DictionaryComponents, Modify } from '../../../../../utils/globals/types'
import useConfigColumns from '../../../../../utils/hooks/useConfigColumns'
import { ButtonConfigColumnsWithModal } from '../../../../../baseComponents/ModalsLayouts/ModalConfigColumnsTabs'
import { ConnectedComponent } from 'react-redux'

export interface VatTableLayoutProps {
    name: string
    translations: {
        headerTitle: string
        tableTitle: string
    }
    children?: React.ReactNode
    buttonSave?: JSX.Element
    inputTableURLs: InputTableURLsTable
    orderHeaderURLs: OrderHeaderURLs
    getCompleteData: (vat?: TableData) => Promise<void>
    tableConfiguration: TableConfiguration
    setTableConfiguration: React.Dispatch<React.SetStateAction<TableConfiguration>>
    rowRenderer?: TableWithoutVirtualListingRowRenderer
    completeData: InputTableLayoutData | null
    setCompleteData: Dispatch<SetStateAction<InputTableLayoutData | null>>
    userPermissions: UserPermissions
    columns: ColumnITLayoutTableConfiguration[]
    hideNotes?: boolean
    components?: DictionaryComponents
    className?: string
    headerChanges?: HeaderChangesTy
    orderStatusDict: TwinDictionary
    InputTableHeaderChildren: ConnectedComponent<React.FC<any>, any>
    modelId: string
}
interface VatTableLayoutFullProps extends VatTableLayoutProps {
    hookFunction: ITHookFunctionTy
    TableChildren: React.FC<InputTableFooterFullProps>
}

const VatTableLayout: React.FC<VatTableLayoutFullProps> = ({ name, translations, children, buttonSave, columns, completeData, className, InputTableHeaderChildren, ...rest }) => {
    const { active, setActive } = useVatTableLayoutLogic()
    return (
        <LoaderDecider loading={completeData === null}>
            <BigTitleAndRightLayout title={translations.headerTitle} className='overflow-y-auto input_table_layout' RightHeader={buttonSave}>
                <WhiteBox className={'input_table_whitebox ' + (active ? 'active' : '')}>
                    <div className='input_table_showicon' onClick={() => setActive((old) => !old)}><TwinIcon icon={active ? faTimes : faBars} /></div>
                    <div className={'input_table_header_column'}>
                        <div className='input_table_header_col_animating flex h-full'>
                            <InputTableHeaderChildren headerData={completeData?.header} updateDataURL={rest?.inputTableURLs?.updateHeaderData} setCompleteData={rest?.setCompleteData} getCompleteData={rest?.getCompleteData} userPermissions={rest?.userPermissions} />
                            {children}
                        </div>
                    </div>
                    <InputTable className={'vat_input_table ' + (className || '')} tableTitle={translations.tableTitle} CurrencyId={completeData?.header?.CurrencyId || ''} completeData={completeData || { header: {}, tableData: [], originalTableData: [], dictPosTableData: {}, filters: { generalSearchbar: '', order: {}, singleFieldsSearch: {} } }} {...{ name, columns, ...rest }} />
                </WhiteBox>
            </BigTitleAndRightLayout>
        </LoaderDecider>
    )
}


const useVatTableLayoutLogic = () => {
    const [active, setActive] = useState(true)
    
    return { active, setActive }
}

export const VatTableLayoutNew: React.FC<VatTableLayoutFullProps> = ({ completeData, ...rest }) => {
    return (
        <LoaderDecider loading={completeData === null}>
            <VatTableLayoutNewLoaded completeData={completeData as InputTableLayoutData} {...rest} />
        </LoaderDecider>
    )
}

type VatTableLayoutNewLoadedProps = Modify<VatTableLayoutFullProps, {
    completeData: InputTableLayoutData
}>

const VatTableLayoutNewLoaded: React.FC<VatTableLayoutNewLoadedProps> = ({ name, translations, buttonSave, columns, completeData, className, InputTableHeaderChildren, children, hookFunction, ...rest }) => {
    const { setSelectedColumnsAndFilters, selectedColumnsAndFilters, memorizedColumns } = useConfigColumns({ columns, name })
    const { ...resty } = hookFunction({ completeData, columns: memorizedColumns, CurrencyId: completeData?.header?.CurrencyId, ...rest })
    const { active, setActive } = useVatTableLayoutNewLogic()
    return (
        <BigTitleAndRightLayout title={translations.headerTitle} className='overflow-y-auto input_table_layout' RightHeader={buttonSave}>
            <WhiteBox className='input_table_whitebox input_table_new_whitebox'>
                <div className={'input_table_top_header_parent flex relative ' + (active ? 'active' : '')}>
                    <div className='flex input_table_new_showicon cursor-pointer absolute bg-white rounded-full items-center justify-center z-3 regular16' onClick={() => setActive((old) => !old)}><TwinIcon icon={active ? faChevronUp : faChevronDown} /></div>
                    <div className='flex items-center gap-x-10 input_table_top_header_content p-20 flex-auto'>
                        <InputTableHeaderChildren headerData={completeData?.header} updateDataURL={rest?.inputTableURLs?.updateHeaderData} tableData={completeData?.tableData} setCompleteData={rest?.setCompleteData} getCompleteData={rest?.getCompleteData} userPermissions={rest?.userPermissions} />
                        <ButtonConfigColumnsWithModal name={name} columns={columns} setSelectedColumnsAndFilters={setSelectedColumnsAndFilters} selectedColumnsAndFilters={selectedColumnsAndFilters} haveFiltersColumn={false} setTableConfiguration={() => { }} getTableDataFromStart={() => { }} />
                    </div>
                    {children}
                </div>
                <InputTableNew className={'vat_input_table ' + (className || '')} CurrencyId={completeData?.header?.CurrencyId || ''} completeData={completeData || { header: {}, tableData: [], originalTableData: [], dictPosTableData: {}, filters: { generalSearchbar: '', order: {}, singleFieldsSearch: {} } }} {...{ name, columns, setSelectedColumnsAndFilters, selectedColumnsAndFilters, memorizedColumns, hookFunction, ...resty, ...rest }} />
            </WhiteBox>
        </BigTitleAndRightLayout>
    )
}

const useVatTableLayoutNewLogic = () => {
    const [active, setActive] = useState(true)
    
    return { active, setActive }
}


export default VatTableLayout